import { STATUS_CONFIG } from '../../constants';

interface ServiceStatusBadgeProps {
  statusGroup: string;
  statusText: string;
}

export const ServiceStatusBadge = ({
  statusGroup,
  statusText,
}: ServiceStatusBadgeProps) => {
  const config = STATUS_CONFIG[statusGroup as keyof typeof STATUS_CONFIG];

  if (!config) {
    return (
      <span className="text-muted-foreground text-sm">
        {statusText || statusGroup || '—'}
      </span>
    );
  }

  const { icon: IconComponent, iconColor, textColor } = config;

  return (
    <div className="flex min-w-0 items-center gap-2">
      <IconComponent className={`h-4 w-4 shrink-0 ${iconColor}`} />
      <span
        className={`truncate ${textColor || 'text-foreground'}`}
        title={statusText}
      >
        {statusText}
      </span>
    </div>
  );
};
